module.exports = __webpack_public_path__ + "media/images/emoji-d51160a17a8f7d143d7a4c86dc1f441b.svg";